import { createContext } from 'react';

import { UserInfoContextType } from './types';

export const UserInfoContext = createContext<UserInfoContextType>(
  undefined as never
);
